/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestResultDto } from '../../models/contents-request-result-dto';

export interface ContentsRequestResultControllerFindAll$Params {
}

export function contentsRequestResultControllerFindAll(http: HttpClient, rootUrl: string, params?: ContentsRequestResultControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContentsRequestResultDto>>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestResultControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContentsRequestResultDto>>;
    })
  );
}

contentsRequestResultControllerFindAll.PATH = '/api/contents-request-result';
